<template>
  <b-row>
    <b-col v-if="showMode" md="3">
      <b-form-group label="Paid By:">
        <b-form-select v-model="details.payout_mode" :options="payoutModes" />
      </b-form-group>
    </b-col>
    <b-col v-if="showReference" md="3">
      <b-form-group label="Reference No:">
        <b-form-input v-model="details.reference_no" placeholder="Optional" />
      </b-form-group>
    </b-col>
    <b-col md="3">
      <b-form-group label="Reason:">
        <b-form-input v-model="details.reason" maxlength="500" />
      </b-form-group>
    </b-col>
  </b-row>
</template>

<script>
export default {
  props: {
    details: { type: Object, required: true },
    payoutModes: { type: Array, required: true },
    showMode: { type: Boolean, default: false },
    showReference: { type: Boolean, default: false },
  },
};
</script>
